import { useEffect, useState } from "react";
import PageHeader from "../../../../Layout/PageHeader";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDown, ChevronUp, Plus, Trash3Fill } from "react-bootstrap-icons";
import FormSelect from "../../../../Components/FormTag/FormSelect";
import {
  allocationDirectionData,
  allocationOperatorData,
  priorityData,
} from "../../../../Data/outbound";
import { SubmitHandler, useForm } from "react-hook-form";
import { CreatePickPlan, ConditionRow, OrderByRow } from "../model/pickplan.model";
import FormButton from "../../../../Components/Buttons/FormButton";
import Table from "../../../../Components/Tables/Table";
import { useStore } from "../../../../store/Store";
import InputFiled from "../../../../Components/FormTag/InputFiled";
import FormToggle from "../../../../Components/FormTag/FormToggle";
import {
  fetchPickTypeLookup,
  fetchPickPlanConditionColumn,
  fetchPickPlanOrderByColumn,
  submitPickPlanForm,
  updatePickPlanForm,
  getPickPlanDetails,
} from "../service/pickplan.service";
import {
  ApiResponse,
  SelcetOption,
} from "../../../../model/common/apiResponse";
import Loader from "../../../../Components/GlobalLoader/Loader";
import toast, { Toaster } from "react-hot-toast";
import { lookUpService } from "../../../../Services/common/lookup.service";

export default function PickPlanAddEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [collapseStates, setCollapseStates] = useState<boolean[]>([true]);
  const [data, setData] = useState<any[]>([]);
  const [conditionTable, setConditionTable] = useState<ConditionRow[]>([]);
  const [showConditionTable, setShowConditionTable] = useState(false);
  const [showOrderbyTable, setShowOrderbyTable] = useState(false);
  const [orderByTable, setorderByTable] = useState<OrderByRow[]>([]);
  const [warehouseData, setWarehouseData] = useState<SelcetOption[]>([]);
  const [pickTypeData, setPickTypeData] = useState<SelcetOption[]>([]);
  const [pickplanColumnData, setpickplanColumnData] = useState<SelcetOption[]>([]);
  const [pickplanOrderByData, setpickplanOrderByData] = useState<SelcetOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const selectedItem = useStore((state) => state.selectedItem);

  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm<CreatePickPlan>({});

  const handleDeleteCondition = (index: number) => {
    const updatedItems = [...conditionTable];
    updatedItems.splice(index, 1);

    // Clear the form values of the deleted row
    setValue(`condition-column-${index}` as any, undefined);
    setValue(`condition-operator-${index}` as any, undefined);
    setValue(`condition-value-${index}` as any, undefined);
    setValue(`isColumnCompareToggled-${index}` as any, undefined);

    updatedItems.forEach((item, i) => {
      setValue(`condition-column-${i}` as any, item.column);
      setValue(`condition-operator-${i}` as any, item.operator);
      setValue(`condition-value-${i}` as any, item.value);
      setValue(`isColumnCompareToggled-${i}` as any, item.isColumnCompareToggled);
    });

    for (let i = updatedItems.length; i < conditionTable.length; i++) {
      setValue(`condition-column-${i}` as any, undefined);
      setValue(`condition-operator-${i}` as any, undefined);
      setValue(`condition-value-${i}` as any, undefined);
      setValue(`isColumnCompareToggled-${i}` as any, undefined);
    }

    setConditionTable(updatedItems);

    if (updatedItems.length === 0) {
      setShowConditionTable(false);
    }
  };

  const handleDeleteOrderBy = (index: number) => {
    const updatedItems = [...orderByTable];
    updatedItems.splice(index, 1);
    // Reset form values for the deleted row
    setValue(`order-by-column-${index}` as any, "");
    setValue(`direction-${index}` as any, "");
    // Update form values
    updatedItems.forEach((item, i) => {
      setValue(`order-by-column-${i}` as any, item.column);
      setValue(`direction-${i}` as any, item.direction);
    });
    setorderByTable(updatedItems);
    if (updatedItems.length === 0) {
      setShowOrderbyTable(false);
    }
  };

  const columnsConditions = [
    {
      name: "Column",
      cell: (row: ConditionRow, index?: number) => (
        <FormSelect
          name={`condition-column-${index}`}
          control={control}
          optionList={pickplanColumnData}
          className="form-control p-0"
          placeholder="Select Column"
          isSearchable={true}
          defaultValue={row.column}
          onChange={(selected) => {
            const updatedRows = [...conditionTable];
            updatedRows[index!] = {
              ...updatedRows[index!],
              column: selected.value,
            };
            setConditionTable(updatedRows);
            setValue(`condition-column-${index}` as any, selected.value);
          }}
        />
      ),
      width: "25%",
    },
    {
      name: "Operator",
      cell: (row: ConditionRow, index?: number) => (
        <FormSelect
          name={`condition-operator-${index}`}
          control={control}
          optionList={allocationOperatorData}
          className="form-control p-0"
          placeholder="Select Operator"
          isSearchable={true}
          defaultValue={row.operator}
          onChange={(selected) => {
            const updatedRows = [...conditionTable];
            updatedRows[index!] = {
              ...updatedRows[index!],
              operator: selected.value,
            };
            setConditionTable(updatedRows);
            setValue(`condition-operator-${index}` as any, selected.value);
          }}
        />
      ),
      width: "25%",
    },
    {
      name: "Value",
      cell: (row: ConditionRow, index: number) =>
        row.isColumnCompareToggled ? (
          <FormSelect
            name={`condition-value-${index}`}
            control={control}
            optionList={pickplanColumnData}
            className="form-control p-0"
            placeholder="Select Value"
            isSearchable={true}
            defaultValue={
              row.value ? { label: row.value, value: row.value } : undefined
            }
            onChange={(selected) => {
              const updatedRows = [...conditionTable];
              updatedRows[index!] = {
                ...updatedRows[index!],
                value: selected.value,
              };
              setConditionTable(updatedRows);
              setValue(`condition-value-${index}` as any, selected.value);
            }}
          />
        ) : (
          <InputFiled
            tabIndex={2}
            type="text"
            register={register}
            name={`condition-value-${index}`}
            className="form-control h-38"
            placeholder="Enter Value"
            defaultValue={row.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const updatedRows = [...conditionTable];
              updatedRows[index] = {
                ...updatedRows[index],
                value: e.target.value,
              };
              setConditionTable(updatedRows);
              setValue(`condition-value-${index}` as any, e.target.value);
            }}
          />
        ),
      width: "25%",
    },
    {
      name: "Column Compare",
      cell: (row: ConditionRow, index?: number) => (
        <div className="pt-2" style={{ paddingLeft: "32px" }}>
          <FormToggle
            register={register}
            name={`isColumnCompareToggled-${index}`}
            tabIndex={13}
            defaultChecked={row.isColumnCompareToggled}
            onChange={() => {
              const updatedRows = [...conditionTable];
              updatedRows[index!] = {
                ...updatedRows[index!],
                isColumnCompareToggled: !row.isColumnCompareToggled,
                value: "",
              };
              setConditionTable(updatedRows);
              setValue(
                `isColumnCompareToggled-${index}` as any,
                !row.isColumnCompareToggled
              );
              setValue(`condition-value-${index}` as any, "");
            }}
          />
        </div>
      ),
    },
    {
      name: "",
      cell: (row: any, index: number) => (
        <Trash3Fill
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteCondition(index);
          }}
        />
      ),
      width: "50px",
    },
  ];

  const columnsOrderBy = [
    {
      name: "Column",
      cell: (row: OrderByRow, index?: number) => (
        <FormSelect
          name={`order-by-column-${index}`}
          control={control}
          optionList={pickplanOrderByData}
          className="form-control p-0"
          placeholder="Select Column"
          isSearchable={true}
          defaultValue={row.column}
          onChange={(selected) => {
            const updatedRows = [...orderByTable];
            updatedRows[index!] = {
              ...updatedRows[index!],
              column: selected.value,
            };
            setorderByTable(updatedRows);
            setValue(`order-by-column-${index}` as any, selected.value);
          }}
        />
      ),
      width: "48%",
    },
    {
      name: "Direction",
      cell: (row: OrderByRow, index?: number) => (
        <FormSelect
          name={`direction-${index}`}
          control={control}
          optionList={allocationDirectionData}
          className="form-control p-0"
          placeholder="Select Direction"
          isSearchable={true}
          defaultValue={row.direction}
          onChange={(selected) => {
            const updatedRows = [...orderByTable];
            updatedRows[index!] = {
              ...updatedRows[index!],
              direction: selected.value,
            };
            setorderByTable(updatedRows);
            setValue(`direction-${index}` as any, selected.value);
          }}
        />
      ),
      width: "47%",
    },
    {
      name: "",
      cell: (row: any, index: number) => (
        <Trash3Fill
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteOrderBy(index);
          }}
        />
      ),
      width: "50px",
    },
  ];

  useEffect(() => {
    if (selectedItem) {
      setData(selectedItem);
    }
  }, [selectedItem]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          pickTypeResponse,
          conditionColumnResponse,
          orderByColumnResponse,
          warehouseResponse,
        ] = await Promise.all([
          fetchPickTypeLookup(),
          fetchPickPlanConditionColumn(),
          fetchPickPlanOrderByColumn(),
          lookUpService.warehouseLookup(),
        ]);

        const pickTypeData =
          pickTypeResponse?.data?.map((obj: any) => ({
            label: obj.description,
            value: obj.code,
          })) || [];

        const conditionColumnData =
          conditionColumnResponse?.data?.map((obj: any) => ({
            label: obj.description,
            value: obj.code,
          })) || [];

        const orderByColumnData =
          orderByColumnResponse?.data?.map((obj: any) => ({
            label: obj.description,
            value: obj.code,
          })) || [];

        const warehouseData =
          warehouseResponse?.data?.data?.results?.map((obj: any) => ({
            label: obj.name,
            value: obj.code,
          })) || [];

        setPickTypeData(pickTypeData);
        setpickplanColumnData(conditionColumnData);
        setpickplanOrderByData(orderByColumnData);
        setWarehouseData(warehouseData);

        // If editing, fetch pick plan details
        if (id) {
          const response = await getPickPlanDetails(id);
          const data = response.data;

          // Set form values
          setValue("description", data.description);
          setValue("warehouse", data.warehouse?.code);
          setValue("pick_method", data.pick_method);
          setValue("priority", data.priority);
          setValue("drop_warehouse_location", data.drop_warehouse_location?.name);
          setValue("max_shipments", data.max_shipment_limit?.toString());

          // Set conditions table
          if (data.configs?.conditions?.length > 0) {
            const conditions = data.configs.conditions.map(
              (condition: [string, string, string], index: number) => {
                const isDropdownValue = conditionColumnData.some(
                  (option: SelcetOption) => option.value === condition[2]
                );
                return {
                  position: index + 1,
                  column: condition[0],
                  operator: condition[1],
                  value: condition[2],
                  isColumnCompareToggled: isDropdownValue,
                };
              }
            );
            setConditionTable(conditions);
            setShowConditionTable(true);

            // Set form values for conditions
            conditions.forEach((condition: any, index: number) => {
              setValue(`condition-column-${index}` as any, condition.column);
              setValue(`condition-operator-${index}` as any, condition.operator);
              setValue(`condition-value-${index}` as any, condition.value);
              setValue(
                `isColumnCompareToggled-${index}` as any,
                condition.isColumnCompareToggled
              );
            });
          }

          // Set order by table
          if (data.configs?.order_bys?.length > 0) {
            const orderBys = data.configs.order_bys.map(
              (orderBy: { column: string; dir: string }, index: number) => ({
                position: index + 1,
                column: orderBy.column,
                direction: orderBy.dir,
              })
            );
            setorderByTable(orderBys);
            setShowOrderbyTable(true);

            // Set form values for order by
            orderBys.forEach((orderBy: any, index: number) => {
              setValue(`order-by-column-${index}` as any, orderBy.column);
              setValue(`direction-${index}` as any, orderBy.direction);
            });
          }
        }
      } catch (error) {
        console.error("Failed to load pick plan:", error);
        toast.error("Failed to load pick plan");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, setValue]);

  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const handleShowCondition = () => {
    setShowConditionTable(true);
    const newBlankRow = {
      position: conditionTable.length + 1,
      column: "",
      operator: "",
      value: "",
      isColumnCompareToggled: false,
    };
    setConditionTable([...conditionTable, newBlankRow]);
    setValue(`condition-column-${conditionTable.length}` as any, "");
    setValue(`condition-operator-${conditionTable.length}` as any, "");
    setValue(`condition-value-${conditionTable.length}` as any, "");
    setValue(`isColumnCompareToggled-${conditionTable.length}` as any, false);
  };

  const handleShowOrderBy = () => {
    setShowOrderbyTable(true);
    const newBlankRow = {
      position: orderByTable.length + 1,
      column: "",
      direction: "",
    };
    setorderByTable([...orderByTable, newBlankRow]);
    setValue(`order-by-column-${orderByTable.length}` as any, "");
    setValue(`direction-${orderByTable.length}` as any, "");
  };

  const nextData: SubmitHandler<CreatePickPlan> = async (formData: any) => {
    setIsFormSubmit(true);
    if (submitting) return;
    setSubmitting(true);

    try {
      const orderBys = [];
      const conditions = [];

      for (let i = 0; i < orderByTable.length; i++) {
        const column = formData[`order-by-column-${i}`];
        const dir = formData[`direction-${i}`];

        if (column && dir) {
          orderBys.push({ column, dir });
        }
      }

      for (let i = 0; i < conditionTable.length; i++) {
        const column = formData[`condition-column-${i}`];
        const operator = formData[`condition-operator-${i}`];
        const value = formData[`condition-value-${i}`];

        if (column && operator && value !== undefined) {
          conditions.push([column, operator, value]);
        }
      }

      const requestPayload = {
        description: formData.description,
        warehouse: {
          code: formData.warehouse,
        },
        ...(formData.pick_method && { pick_method: formData.pick_method }),
        ...(formData.priority && { priority: formData.priority }),
        ...(formData.drop_warehouse_location && {
          drop_warehouse_location: {
            name: formData.drop_warehouse_location,
          },
        }),
        ...(formData.max_shipments && {
          max_shipment_limit: Number(formData.max_shipments),
        }),
        configs: {
          order_bys: orderBys,
          conditions: conditions,
        },
      };

      const response = id
        ? await updatePickPlanForm(id, requestPayload)
        : await submitPickPlanForm(requestPayload);

      if (response.status === 200 || response.status === 201) {
        toast.success(
          id
            ? "Pick Plan updated successfully!"
            : "Pick Plan created successfully!",
          { duration: 1000 }
        );
        setTimeout(() => {
          navigate("/outbound/pick-plans");
        }, 1000);
      } else {
        if (typeof response.error.detail === "string") {
          toast.error(response.error.detail, { duration: 2000 });
        } else if (typeof response.error.detail === "object") {
          const messages = Object.entries(response.error.detail)
            .map(([field, errors]) => `${(errors as string[]).join(", ")}`)
            .join("\n");
          toast.error(messages, { duration: 2000 });
        }
      }
    } catch (error) {
      toast.error(
        id
          ? "An error occurred while updating Pick Plan."
          : "An error occurred while creating Pick Plan.",
        {
          duration: 2000,
        }
      );
    } finally {
      setSubmitting(false);
      setIsFormSubmit(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Toaster />
      <PageHeader
        addUrl="/outbound/pick-plans/add"
        listUrl="/outbound/pick-plans"
        viewType={true}
      />
      <h5 className="text-start mt-1 mb-3">
        {id ? `Edit Pick Plan (${id})` : "Create Pick Plan"}
      </h5>
      <div className="my-2 bg-white rounded py-4 pb-4 px-2">
        <div className="d-flex justify-content-between">
          <div className="px-3 col">
            {collapseStates[0] ? (
              <>
                <div className="row">
                  <div className="col">
                    <label className="fw-bold">Description </label>
                    <span className="text-danger ms-1">*</span>
                    <div className="mt-2">
                      <InputFiled
                        tabIndex={2}
                        type="text"
                        register={register}
                        required={true}
                        name="description"
                        errors={errors.description}
                        className="form-control"
                        placeholder="Enter Description"
                      />
                    </div>
                  </div>

                  <div className="col">
                    <label className="fw-bold">Warehouse</label>
                    <span className="text-danger ms-1">*</span>
                    <div className="mt-2">
                      <FormSelect
                        tabIndex={5}
                        name="warehouse"
                        control={control}
                        optionList={warehouseData}
                        className="form-control p-0"
                        placeholder="Select Warehouse"
                        isSearchable={true}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <label className="fw-bold">Drop Location</label>
                    <span className="text-danger ms-1">*</span>
                    <div className="mt-2">
                      <InputFiled
                        tabIndex={2}
                        maxLength={50}
                        type="text"
                        register={register}
                        name="drop_warehouse_location"
                        className="form-control"
                        placeholder="Enter Drop Location"
                        required={true}
                        errors={errors.drop_warehouse_location}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label className="fw-bold">Pick Type</label>
                    <div className="mt-2">
                      <FormSelect
                        tabIndex={5}
                        name="pick_method"
                        control={control}
                        optionList={pickTypeData}
                        className="form-control p-0"
                        placeholder="Select Pick Type"
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <label className="fw-bold">Priority</label>
                    <div className="mt-2">
                      <FormSelect
                        tabIndex={5}
                        name="priority"
                        control={control}
                        optionList={priorityData}
                        className="form-control p-0"
                        placeholder="Select Priority"
                        isSearchable={true}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <label className="fw-bold">Max Shipments</label>
                    <div className="mt-2">
                      <InputFiled
                        tabIndex={2}
                        maxLength={50}
                        type="text"
                        register={register}
                        name="max_shipments"
                        className="form-control"
                        placeholder="Enter Max Shipments"
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className=" d-flex justify-content-between">
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Description
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {getValues("description") || "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Priority
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {priorityData.find(
                      (p: SelcetOption) => p.value === getValues("priority")
                    )?.label || "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Pick Type
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {pickTypeData.find(
                      (p: SelcetOption) => p.value === getValues("pick_method")
                    )?.label || "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Warehouse
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {warehouseData.find(
                      (w: SelcetOption) => w.value === ((getValues("warehouse") as any)?.code ?? getValues("warehouse"))
                    )?.label || "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Drop Location
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {((getValues("drop_warehouse_location") as any)?.name ?? getValues("drop_warehouse_location")) || "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Max Shipments
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {getValues("max_shipments") || "-"}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="align-self-start">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(0)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {collapseStates[0] && (
          <form>
            <div className="d-flex px-2 gap-3"></div>
          </form>
        )}
      </div>
      <div className="d-flex justify-content-between px-2 mt-3 ">
        <h6 className="text-start mb-1">Conditions</h6>
        <div onClick={handleShowCondition} className="d-flex align-items-center">
          <small className="cursor-pointer fw-bold mb-2 fs-14">
            Add a Condition
          </small>
          <div className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center bg-white">
            <Plus />
          </div>
        </div>
      </div>
      {showConditionTable && (
        <div className="my-2 bg-white rounded py-3 px-3">
          <Table
            key={conditionTable.length}
            data={conditionTable}
            columns={columnsConditions}
            CheckboxStatus={false}
            isStripped={true}
            enableScrollbar={true}
            customClassName="transferDetailsTable"
          />
        </div>
      )}

      <div className="d-flex justify-content-between px-2 mt-3 ">
        <h6 className="text-start mb-1">Order By</h6>
        <div onClick={handleShowOrderBy} className="d-flex align-items-center">
          <small className="cursor-pointer fw-bold mb-2 fs-14">Order By</small>
          <div className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center bg-white">
            <Plus />
          </div>
        </div>
      </div>

      {showOrderbyTable && (
        <div className="my-2 bg-white rounded py-3 px-3">
          <Table
            data={orderByTable}
            columns={columnsOrderBy}
            CheckboxStatus={false}
            enableScrollbar={true}
            isStripped={true}
            customClassName="transferDetailsTable"
          />
        </div>
      )}
      <div className=" bg-white rounded py-3 mt-auto">
        <div className="d-flex flex-row-reverse">
          <FormButton
            disabled={isFormSubmit}
            tabIndex={3}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
          >
            {id ? "Update" : "Submit"}
          </FormButton>
          <FormButton
            tabIndex={4}
            className="sph-btn sph-shift me-4"
            handleClick={() => {
              navigate("/outbound/pick-plans");
            }}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
